import React from 'react';

import styles from './Container.module.css';

export default function Container({ align, className, ...props }) {
  const classes = [styles.container, className];

  if (align) classes.push(`text-${align}`);

  return <div className={classes.join(' ')} {...props} />;
}
